define('static/not-found',['durandal/app'], function(app) {
    var viewmodel = function() {
        var self = this;
        self.canActivate = function() {
            return true;
        };
    };
    return viewmodel;
});
